import { Routes } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MailchimpComponent } from './mailchimp/mailchimp.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginCredentialsComponent } from './user/login-credentials/login-credentials.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { AuthGuard } from './guards/auth.guard';
import { SuperAdminGuard } from './guards/super-admin.guard';
import { HandleQrCodeComponent } from './handle-qr-code/handle-qr-code.component';
import { SystemBannersListComponent } from './system-banners/system-banners-list/system-banners-list.component';

export const ROUTES: Routes = [
  { path: '', component: SignInComponent },
  { path: 'about', component: AboutComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'contact-us', component: ContactUsComponent },
  {
    path: 'handle-qr-code/:code_hash',
    component: HandleQrCodeComponent
  },
  {
    path: 'login-credentials',
    component: LoginCredentialsComponent,
    canActivate: [
      AuthGuard
    ]
  },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  // Partner welcome email: the customer sets a password (public).
  { path: 'set-password/:token', component: SetPasswordComponent },
  { path: 'verify-email/:token', component: VerifyEmailComponent },
  { path: 'release-notes', component: ReleaseNotesComponent },
  {
    // Platform-wide banners shown to every account. Reached from the system administrators menu.
    path: 'system-banners',
    component: SystemBannersListComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ]
  },
  {
    // Internal Mailchimp list tool. It has no menu entry and nothing links to it, but it was
    // reachable by URL with any authenticated session.
    path: 'system',
    component: MailchimpComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ],
    children: [
      {
        path: 'mailchimp',
        component:
        MailchimpComponent
      }
    ]
  },
  { path: '**', component: PageNotFoundComponent },
  { path: 'not-found', component: PageNotFoundComponent }
];
